import type { FallbackProps } from 'react-error-boundary'

import Typography from '@ui/Typography/Typography'

import * as styles from './AudioSettingsModalError.css'

export default function AudioSettingsModalError({ error }: FallbackProps) {
  return (
    <div className={styles.root}>
      {/*
       // @ts-expect-error Provide Typography with a component prop */}
      <Typography variant="callout" color="textSecondary">
        {(error as Error).message}
      </Typography>
    </div>
  )
}
